import { computed, inject, Injectable } from '@angular/core';
import { ChecklistItem } from '@suvo/frontend-framework/SUVO-CORE-CLIENT-LIB/projects/suvo-core-client-lib/src/lib/features/checklist';
import { SitemapEditingService } from '../../sitemap/services/sitemap-editing.service';

@Injectable()
export class PagesChecklistItem implements ChecklistItem {
  private readonly sitemaps = inject(SitemapEditingService).sitemaps;

  readonly title = 'Create pages for your site';
  readonly routerLink = '/private/pages';

  readonly isChecked = computed(() =>
    this.sitemaps().some(
      (tree) => (tree.type === 'private' || tree.type === 'public') && tree.routes.length,
    ),
  );
}
